<template>
  <v-card :style="backOpacity">
    <v-card-title>削除ボタンフォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!--
          {{ returnData }}
          {{ formIDs }}
          rules:{{ rules }}<br />
          {{ actions }}
          -->
          <v-row>
            <v-col cols="auto">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[0]"
                label="確認モーダル表示"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="rules[0] == 'true'">
              <v-checkbox
                v-model="rules[1]"
                label="確認文章をラベルと連動"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                :items="$store.state.colors"
                v-model="returnData.color"
                label="ボタンの色"
                :rules="[varidation.required]"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="textColors"
                item-text="label"
                item-value="value"
                v-model="textColor"
                label="テキストの色"
              ></v-select
            ></v-col>
          </v-row>
          <v-row v-for="(v, i) in arr" :key="i">
            <v-col cols="2">
              <v-text-field
                label="ラベル"
                :rules="[]"
                v-model="v.label"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="ラベル条件(id1.id2)"
                    :rules="[]"
                    v-model="v.terms"
                    required
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <span
                  >ID 0~2個(id1 == null) または (id1 == null && id2 != null)
                  id:Xの時 if id == Xの場合ラベル変更</span
                >
              </v-tooltip>
            </v-col>

            <v-col cols="2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-select
                    :items="authority"
                    item-text="label"
                    item-value="value"
                    v-model="v.auth"
                    label="クリック可"
                    v-bind="attrs"
                    v-on="on"
                  ></v-select>
                </template>
                <span>ラベルXの時、クリックできるユーザ権限を指定</span>
              </v-tooltip>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="actions"
                item-text="label"
                item-value="value"
                v-model="v.action"
                label="動作"
              ></v-select>
            </v-col>
            <v-col
              cols="2"
              v-if="v.action == 'formID' || v.action == 'formIDmulti'"
            >
              <v-text-field
                label="削除formID"
                :rules="[varidation.numonly]"
                v-model.number="v.formID"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">
              <v-btn @click="add" class="ma-2">追加</v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn :disable="arr.length > 1" @click="del" class="ma-2"
                >削除</v-btn
              >
            </v-col>
            <v-col class="ma-2"
              >*条件式は上から順番に判断される<br />「動作」の特定フォーム削除(複数)は特定フォーム削除の連結用です<br />先に複数を指定し次に通常の物を指定してください。原則、動作と削除formID以外は全て同じ指定です</v-col
            >
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :color="returnData.color + ' ' + textColor"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    //個別値
    value: Array,
    color: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        //個別値
        value: this.value,
        color: this.color,
      },
      backOpacity: "opacity: 1",
      //
      base: {
        label: "削除",
        action: "",
        formID: 0,
        auth: "general",
        terms: "",
      },
      arr: [{ label: "削除", action: "", formID: 0, auth: "all", terms: "" }],

      //
      actions: [
        { label: "レポート削除", value: "" },
        { label: "特定フォーム削除", value: "formID" },
        { label: "特定フォーム削除(複数)", value: "formIDmulti" },
      ],
      authority: [
        { label: "全て", value: "all" },
        { label: "一般のみ", value: "general" },
        { label: "管理者", value: "admin" },
        { label: "第3属性", value: "other" },
        { label: "削除不可", value: "disable" },
        { label: "削除可", value: "enable" },
        //{ label: "ラベル条件と同一", value: "terms" },
      ],
      textColor: "",
      textColors: [
        { label: "black", value: "" },
        { label: "white", value: "white--text" },
      ],
      //
      rules: ["", ""],
      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  mounted() {
    if (this.value != null) {
      this.arr = this.value;
    }
    [
      this.returnData.color,
      this.textColor,
      this.rules[0],
      this.rules[1],
    ] = this.color.split(",");
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if (this.rules[0] != "true") {
          this.rules[1] = "";
        }

        this.returnData.value = this.arr;
        this.returnData.color +=
          "," + this.textColor + "," + this.rules.join(",");

        this.$emit("clickSubmit", this.returnData);
      }
    },
    add() {
      const max = 20;
      if (this.arr.length < max) {
        this.arr.push(JSON.parse(JSON.stringify(this.base)));
      }
    },
    del() {
      //if (this.arr.length > 1) {
      this.arr.splice(-1, 1);
      //}
    },
  },
};
</script>
